<div class="form-container">
  <div class="cardLayout">

    <!-- OTP Modal -->
    <div class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">OTP Login</h5>
            <button type="button" class="btn-close" (click)="closeOtpModal()"></button>
          </div>

          <div class="modal-body">

            <!-- STEP 1: ENTER EMAIL -->
            <div *ngIf="!otpSent">
              <ion-col size="12" class="mt-10">
                <img src="./assets/icon/emailIcon.svg" class="mailIcon">
                <input type="text" placeholder="Email ID" class="inputstyle font_regular olnone form-control"
                  autocomplete="off" name="userEmailOrPhone" [(ngModel)]="userEmailOrPhone" required />
              </ion-col>

              <ion-row>
                <ion-col size="12">
                  <button type="button" class="text-center fs-16 fs_14ForMobile font_semibold login-btn fs_14ForMobile"
                    (click)="sendOtp()">
                    Send OTP
                  </button>
                </ion-col>
              </ion-row>
            </div>

            <!-- STEP 2: ENTER OTP -->
            <div *ngIf="otpSent" class="otp-card">
              <div class="icon-wrapper">
                <img src="./assets/icon/lock-icon.svg" alt="Lock Icon" class="email-icon">
              </div>

              <h2 class="title">Enter OTP</h2>
              <p class="subtitle">We’ve sent a code to <b>{{ userEmailOrPhone }}</b></p>

              <div class="otp-inputs">
                <input type="text" maxlength="1" [(ngModel)]="otpDigits[0]" name="d1" (input)="moveNext($event, 0)" />
                <input type="text" maxlength="1" [(ngModel)]="otpDigits[1]" name="d2" (input)="moveNext($event, 1)" />
                <input type="text" maxlength="1" [(ngModel)]="otpDigits[2]" name="d3" (input)="moveNext($event, 2)" />
                <input type="text" maxlength="1" [(ngModel)]="otpDigits[3]" name="d4" (input)="moveNext($event, 3)" />
                <input type="text" maxlength="1" [(ngModel)]="otpDigits[4]" name="d5" (input)="moveNext($event, 4)" />
                <input type="text" maxlength="1" [(ngModel)]="otpDigits[5]" name="d6" (input)="moveNext($event, 5)" />
              </div>


              <button class="send-btn" (click)="verifyOtp()">Verify</button>

              <div class="resend-section">
                <span *ngIf="resendCountdown > 0">Resend in {{ resendCountdown }}s</span>
                <a *ngIf="resendCountdown === 0" (click)="resendOtp()">Resend Code</a>
              </div>

              <button class="change-email" type="button" (click)="reset()">Change Email</button>
            </div>

          </div>

        </div>
      </div>
    </div>

  </div>
</div>